var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.table),function(line,index){return _c('div',{key:index,staticClass:"item d-flex"},[_c('div',{staticClass:"list-item"},[_vm._v(_vm._s(line.left))]),_c('div',{staticClass:"right"},[_vm._v(_vm._s(line.right))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }